import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import { getLanguageHeaders } from "../services/http-common";

export const GetLabData = createAsyncThunk("settings/GetLabData", async (token, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI;

    try {
        const response = await fetch(`${config.apiUrl}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        const data = await response.json();

        if (!response.ok) {
            return rejectWithValue(data?.message ?? 'Failed to fetch vendor data');
        }

        return fulfillWithValue(data);
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const UpdateLabData = createAsyncThunk("settings/UpdateLabData", async (obj, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI;

    try {
        const baseHeaders = {
            Accept: "application/json",
            Authorization: `Bearer ${obj.token}`,
            ...getLanguageHeaders(),
        };

        let response;
        if (obj.logoFile) {
            const fd = new FormData();
            Object.entries(obj.values ?? {}).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }
                if (typeof value === "boolean") {
                    fd.append(key, value ? "1" : "0");
                    return;
                }
                fd.append(key, String(value));
            });
            fd.append("logo", obj.logoFile);
            response = await fetch(`${config.apiUrl}`, {
                method: "POST",
                body: fd,
                headers: baseHeaders,
            });
        } else {
            response = await fetch(`${config.apiUrl}`, {
                method: "PUT",
                body: JSON.stringify(obj.values),
                headers: {
                    ...baseHeaders,
                    "Content-Type": "application/json",
                },
            });
        }

        const data = await response.json();

        if (!response.ok) {
            return rejectWithValue(data?.message ?? 'Failed to update vendor');
        }

        return fulfillWithValue(data);
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const LabDataSlice = createSlice({
    name: "settings",
    initialState: {
    settings: null,
        fetchData: null,
        error: null,
        loading: false,
        updateSettings: '',
    },
    extraReducers: {

        //GetLabData actions
        [GetLabData.pending]: (state, action) => {
            state.loading = true
            state.fetchData = null
        },
        [GetLabData.fulfilled]: (state, action) => {
            state.loading = false
            state.settings = {
                ...(action.payload.data ?? {}),
                branches: action.payload.data?.branches ?? [],
            }
            state.fetchData = "fetch"
        },
        [GetLabData.rejected]: (state, action) => {
            state.loading = false
            state.fetchData = null
            state.error = action.payload ?? action.error?.message ?? null
        },
        [UpdateLabData.pending]: (state, action) => {
            state.loading = true
            state.updateSettings = ''
        },
        [UpdateLabData.fulfilled]: (state, action) => {
            state.loading = false
            state.updateSettings = 'update'
            state.settings = {
                ...(action.payload.data ?? {}),
                branches: action.payload.data?.branches ?? [],
            }
        },
        [UpdateLabData.rejected]: (state, action) => {
            state.loading = false
            state.updateSettings = 'update failed'
            state.error = action.payload ?? action.error?.message ?? null
        },
    }
})

export default LabDataSlice.reducer;
